import { Button, Color, Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { openBankingErrorCommonKeys, openBankingErrorDescriptions } from './consts/openBankingErrorTranslationKeys'
import { shineErrorCommonKeys, shineErrorDescriptions } from './consts/shineErrorTranslationKeys'
import { BankConnectionErrorType } from './enums/bankConnectionErrorType'
import * as Styled from './styles'

interface BankConnectionErrorBodyProps {
  errorType: BankConnectionErrorType
  onClose: () => void
}

export const BankConnectionErrorBody = ({ errorType, onClose }: BankConnectionErrorBodyProps): ReactElement => {
  const { t } = useTranslation()

  const translationKeys = useMemo(() => {
    const isOpenBanking =
      errorType === BankConnectionErrorType.OpenBankingConnect || errorType === BankConnectionErrorType.OpenBankingMerge

    const commonKeys = isOpenBanking ? openBankingErrorCommonKeys : shineErrorCommonKeys
    const description = isOpenBanking ? openBankingErrorDescriptions[errorType] : shineErrorDescriptions[errorType]

    return {
      ...commonKeys,
      description,
    }
  }, [errorType])

  return (
    <Flex flexDirection="column" alignItems="center" gap={Spacing.S12}>
      <Styled.IconWrapper>
        <Icon icon="circleX" color={Color.Red400} />
      </Styled.IconWrapper>
      <Text variant="h3">{t(translationKeys.title)}</Text>
      <Text variant="bodyLG" colorVariant="secondary" alignment="center">
        {t(translationKeys.description)}
      </Text>
      <Styled.ButtonWrapper>
        <Button onClick={onClose} borderRadius="9999px">
          {t(translationKeys.cta)}
        </Button>
      </Styled.ButtonWrapper>
    </Flex>
  )
}
